export default __webpack_public_path__ + "static/media/titlePhone.3375454e.png";